import { apiClient } from './httpClient';
// AI 生成场景图像
export async function generateSceneImage(data) {
    const response = await apiClient.post('/ai/generate-scene-image', data);
    return response.data;
}
// 从剧本生成分镜列表
export async function generateStoryboardFromScript(projectId) {
    const response = await apiClient.post(`/projects/${projectId}/generate-storyboard`);
    return response.data;
}
// 创建场景
export async function createScene(projectId, data) {
    const response = await apiClient.post(`/projects/${projectId}/scenes`, data);
    return response.data;
}
// 获取项目的所有场景
export async function getProjectScenes(projectId) {
    const response = await apiClient.get(`/projects/${projectId}/scenes`);
    return response.data;
}
// 更新场景
export async function updateScene(projectId, sceneId, data) {
    const response = await apiClient.put(`/projects/${projectId}/scenes/${sceneId}`, data);
    return response.data;
}
// 删除场景
export async function deleteScene(projectId, sceneId) {
    await apiClient.delete(`/projects/${projectId}/scenes/${sceneId}`);
}
